<template>
<div class="Signer-container mb-2 bg-white text-text-secondary">
  <div>
    <app-material-icon name="drag_indicator" color="icon-secondary" class="Signer-grabIcon mr-2" />
    {{signer.fullName}}
  </div>
  {{index}}

</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

export default defineComponent({
  name: 'SignersOrderQualifiedSigner',
  props: {
    signerId: {
      type: Number,
      required: true,
    },
    index: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    ...mapGetters('groups', ['allRoomMembers']),
    signer () {
      return this.allRoomMembers.find((member: ObjectWith<{ id: number }>) => member.id === this.signerId)
    },
  },
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.Signer {
  &-container {
    background: rgb(var(--v-theme-surface-primary));
    border: get-border('border-secondary');
    @include border-radius('border-radius-2');
    padding: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-grabIcon {
    cursor: grab;
  }
}
</style>
